// @ts-nocheck
/**
 * Inserts text at the current cursor position in the Monaco editor.
 * @param {object} editor - The Monaco editor instance.
 * @param {string} text - The text to insert.
 * @param {object} monaco - The monaco instance (optional, defaults to window.monaco).
 */
export const insertTextAtCursor = (editor, text, monaco = window.monaco) => {
  if (!text || !monaco) {
    return;
  }

  const position = editor?.getPosition?.();
  if (!position) {
    return;
  }

  const range = new monaco.Range(
    position.lineNumber,
    position.column,
    position.lineNumber,
    position.column
  );
  const op = {
    range: range,
    text: text,
    forceMoveMarkers: true,
  };
  editor.executeEdits('smart-value-insert', [op]);
  editor.pushUndoStop();
  editor.focus();
};
